import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-global-header',
  templateUrl: './global-header.component.html',
  styleUrls: ['./global-header.component.scss']
})
export class GlobalHeaderComponent implements OnInit {

  public isCes: boolean = false;
  public isEqh: boolean = false;

  constructor(private router: Router) { }

  ngOnInit() {
    if (this.router.url.includes("/ces")) {
      this.isCes = true;
    }else{
      this.isEqh = true;
    }
  }

}
